export default {
  table: {
    id: "ID",
    name: "Nazwa",
    users: "Użytkownicy",
    usersCount: "Liczba użytkowników",
    fullname: "Imię i nazwisko",
    email: "Email",
    role: "Rola",
  },
  actions: {
    users: "Użytkownicy zespołu",
  },
  form: {
    name: "Nazwa zespołu",
    users: "Użytkownicy",
    addUser: "Dodaj użytkowników",
    userId: "ID użytkownika",
    selectUser: "Wybierz użytkownika",
    searchUser: "Wyszukaj użytkownika",
    selectRole: "Wybierz rolę",
    add: "Dodaj",
    selectedUsers: "Wybrani użytkownicy",
    selectAtLeastOneUser: "Wybierz co najmniej jednego użytkownika",
    leaderAlreadyExists: "W zespole już istnieje lider",
    onlyOneLeaderAllowed: "Można dodać tylko jednego lidera",
  },
  roles: {
    leader: "Lider",
    member: "Członek",
  },
  confirmDelete: "Czy na pewno chcesz usunąć ten zespół?",
  confirmRemoveUser: "Czy na pewno chcesz usunąć tego użytkownika z zespołu?",
};
